import { uiText, useAccountLocale } from '../../i18n';
import { useEffect, useRef, type ReactNode } from 'react';
/** Нативный modal удерживает фокус и исключает фон из клавиатурной навигации. */
export function CloneDialog({ label, busy, onClose, children }: {
    label: string;
    busy: boolean;
    onClose(): void;
    children: ReactNode;
}) {
    useAccountLocale(); // смена языка профиля перерисовывает подпись окна
    const ref = useRef<HTMLDialogElement>(null);
    useEffect(() => {
        const dialog = ref.current;
        const previous = document.activeElement as HTMLElement | null;
        if (dialog?.showModal)
            dialog.showModal();
        else
            dialog?.setAttribute('open', '');
        return () => {
            if (dialog?.close)
                dialog.close();
            if (previous?.isConnected)
                previous.focus();
        };
    }, []);
    return <dialog ref={ref} className="clone-dialog" aria-label={uiText(label)} tabIndex={-1} onCancel={event => { event.preventDefault(); if (!busy)
        onClose(); }} onKeyDown={event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                if (!busy)
                    onClose();
            }
            if (event.key !== 'Tab')
                return;
            const dialog = ref.current;
            const items = Array.from(dialog?.querySelectorAll<HTMLElement>('button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),a[href],[tabindex]') || []).filter(element => element.tabIndex >= 0 && !element.closest('[hidden],[inert],[aria-hidden="true"]') && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden');
            const first = items[0], last = items[items.length - 1];
            if (!first) {
                event.preventDefault();
                dialog?.focus();
            }
            else if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement as HTMLElement))) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement as HTMLElement))) {
                event.preventDefault();
                first.focus();
            }
        }}>
    {uiText(children)}
  </dialog>;
}
